import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=60f486e2"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f486e2')) {
      api.createRecord('60f486e2', component.options)
    } else {
      api.reload('60f486e2', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=60f486e2", function () {
      api.rerender('60f486e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/treasury_accounts/Index.vue"
export default component.exports